import './chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.DelayRenderChartView extends CustomerVisualMode.Charts.ChartView

  render: ->
    super()
    setTimeout =>
      @_renderChart()
    , 100
    @

  onWidthChange: =>
    @chart?.reflow()
